<template>
    <div class="yy-select-member-153-search scroll-content-horizonal" ref="scrollContent">
        <Scroller v-show="!loading">
            <SearchMemberResult v-if="showSearchMember" ref="searchMemberResult"/>
            <template v-for="(tab, index) in root.tabs">
                <SearchMemberResult v-if="tab === SectionTabs.MEMBER" :key="index" ref="searchResults" :tab="tab"/>
                <SearchDeptResult v-else-if="tab === SectionTabs.DEPT || tab === SectionTabs.DEPT_MEMBER" :key="index" ref="searchResults" :tab="tab"/>
                <SearchGroupResult v-else-if="tab === SectionTabs.GROUP || tab === SectionTabs.GROUP_MEMBER" :key="index" ref="searchResults" :tab="tab"/>
                <SearchTeamResult v-else-if="tab === SectionTabs.TEAM || tab === SectionTabs.TEAM_MEMBER" :key="index" ref="searchResults" :tab="tab"/>
                <SearchRoleResult v-else-if="tab === SectionTabs.ROLE || tab === SectionTabs.ROLE_MEMBER" :key="index" ref="searchResults" :tab="tab"/>
            </template>
            <template v-for="(tab, index) in searchableCustomTabs">
                <SearchCustomResult :key="'custom' + index" ref="searchResults" :tab="tab"/>
            </template>
            <Empty type="search" class="yy-select-member-153-search-empty"/>
            <div style="height: 50px"></div>
        </Scroller>
        <Loading v-model="loading"/>
    </div>
</template>
<script>
    import Emitter from '../../../../mixins/emitter'

    import Empty from '../../../base/empty/'
    import Load from '../../../base/page/'
    import Scroller from '../../../base/scroller/'
    import Locale from '../../../../mixins/locale'
    import Loading from '../../../base/loading/'

    import SearchCustomResult from './custom';
    import SearchMemberResult from './member';
    import SearchDeptResult from './dept';
    import SearchGroupResult from './group';
    import SearchTeamResult from './team';
    import SearchRoleResult from './role';

    import { SectionTabs } from '../val';

    export default {
        name: 'YYSearch',
        mixins: [Locale, Emitter],
        components: {
            Empty,
            Load,
            Scroller,
            Loading,
            SearchCustomResult,
            SearchMemberResult,
            SearchDeptResult,
            SearchGroupResult,
            SearchTeamResult,
            SearchRoleResult
        },
        inject: ['root'],
        data() {
            return {
                loading: false,
                hasMore: true,
                SectionTabs,
                searchableCustomTabs: [],
                seachFlag: true
            }
        },
        computed: {
            hasData() {
                return !!(this.member.length || this.dept.length || this.group.length || this.team.length || this.customs.length)
            },
            isEmpty() {
                return !this.loading && !this.hasMore && !this.hasData
            },
            deptIds() {
                const { deptList = [], orgId } = this.root
                return deptList && deptList.map((item)=>{
                    return item.deptId
                }).join(',') || orgId
            },
            showSearchMember() {
                const tabs = this.root.tabs;
                let hasOtherMember = false;
                let hasMember = false;
                for (let i in tabs) {
                    const tab = tabs[i];
                    if (tab === 'member') hasMember = true;
                    else if (typeof tab === 'string' && tab.endsWith('Member')) hasOtherMember = true;
                }
                return !hasMember && hasOtherMember;
            }
        },
        methods: {
            handleChecked(checked, data) {
                data.checked = checked
                this.$emit('handleSelected', data)
            },
            initSearch() {
                this.root.handleSearch = () => {
                    if(!this.root.keyword.trim()) {
                        return this.root.insearch = false
                    }                    
                    this.searchableCustomTabs = this.root.customTabs.filter(tab => typeof tab.onSearch === 'function');
                    if(!this.seachFlag){
                        return;
                    }
                    this.$nextTick(() => {
                        this.root.insearch = true;
                        this.seachFlag = false
                        this.loading = true;
                        this.$nextTick(() => {
                            Promise.all([this.$refs.searchMemberResult, ...this.$refs.searchResults].map(ref => {
                                if (!ref) return Promise.resolve();
                                ref.resetSearch();
                                return ref.handleSearch();
                            })).then(() => {
                                this.loading = false
                                this.hasMore = false
                                this.seachFlag = true
                            }).catch(err => {
                                this.seachFlag = true
                            })
                        })

                    })
                }
            },
        },
        created() {
            this.initSearch()
        }
    }
</script>
